import React from 'react';
import styled from 'styled-components';

type FootnoteMarkerProps = {
  level?: keyof typeof characterMap;
};

const characterMap = {
  0: '*',
  1: '**',
  2: '†',
  3: '‡',
};

const FootnoteMarkerStyled = styled.span`
  vertical-align: top;
`;

const FootnoteMarker: React.FC<FootnoteMarkerProps> = (props) => {
  const { level = 0 } = props;
  return <FootnoteMarkerStyled>{characterMap[level]}</FootnoteMarkerStyled>;
};

export default FootnoteMarker;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FootnoteMarker.tsx